export const pubgMobileCalculatorSkillContract = {
  id: 'pubg_mobile_calculator',
  version: '1.0.0',
  name: 'Calculadora PUBG Mobile',
  domain: 'fps_mobile',
  supportedGames: ['pubg_mobile'],
  description: 'Calcula miras e sensibilidades de PUBG Mobile a partir de uma arma, uma mira base, um valor base e o tipo de sensibilidade.',
  intentExamples: [
    'quero calcular as miras da AKM',
    'calcula AKM Red Dot 115 ADS Gyro',
    'M416 4x 130 ADS',
    'Groza red dot 120 gyro',
    'calcula minha sensi da M416 no PUBG'
  ],
  requiredSlots: ['game', 'weapon', 'baseScope', 'baseValue', 'sensitivityType'],
  optionalSlots: ['language', 'requestId'],
  slotAliases: {
    baseScope: ['mainScope', 'scope', 'mira', 'miraBase'],
    baseValue: ['knownPerfectValue', 'value', 'valor', 'valorBase'],
    sensitivityType: ['controlMode', 'type', 'tipo', 'tipoSensibilidade']
  },
  slotSchemas: {
    game: {
      type: 'enum',
      values: ['pubg_mobile'],
      aliases: ['pubg', 'pubg mobile']
    },
    weapon: {
      type: 'string',
      source: 'official_pubg_weapon_catalog'
    },
    baseScope: {
      type: 'string',
      source: 'official_pubg_scope_catalog',
      aliases: ['mainScope', 'scope', 'mira', 'miraBase']
    },
    baseValue: {
      type: 'number',
      aliases: ['knownPerfectValue', 'value', 'valor', 'valorBase'],
      description: 'Valor que o usuario considera bom na mira base.'
    },
    sensitivityType: {
      type: 'enum',
      values: ['Camera', 'ADS', 'Gyro', 'ADS Gyro'],
      aliases: ['controlMode', 'type', 'tipo', 'tipoSensibilidade']
    },
    language: { type: 'string' },
    requestId: { type: 'string' }
  },
  askForMissingSlots: {
    game: 'Essa calculadora e para PUBG Mobile. Quer calcular PUBG?',
    weapon: 'Qual arma voce quer calcular?',
    baseScope: 'Qual mira voce ja tem como base?',
    baseValue: 'Qual valor esta bom nessa mira base?',
    sensitivityType: 'Qual tipo de sensibilidade: Camera, ADS, Gyro ou ADS Gyro?'
  },
  execution: {
    handler: 'PubgMobileCalculatorSkillAdapter',
    requiresBackend: true,
    backendRoute: '/api/pubg-calculator/analyze',
    costClass: 'low',
    requiresCredits: false,
    requiresPlan: 'free_limited_or_pro_or_pubg_lifetime'
  },
  output: {
    mode: 'conversation',
    schema: 'calculator_result'
  },
  guardrails: {
    doNotPutFormulaInContract: true,
    doNotDuplicateCatalog: true,
    backendCalculatorIsAuthoritative: true,
    preserveIdempotencyRequestId: true,
    doNotExposePremiumCatalogForLockedUsers: true,
    doNotPromiseCodmCalculator: true
  },
  capabilityMapping: {
    primaryCapabilityId: 'calculator_pubg',
    relatedCapabilityIds: []
  }
};

export default pubgMobileCalculatorSkillContract;
